import * as React from "react";
import type { SVGProps } from "react";
const SvgPocket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 3V2zm16 0V2zm-8 18v1zM8.707 9.293a1 1 0 0 0-1.414 1.414zM12 14l-.707.707a1 1 0 0 0 1.414 0zm4.707-3.293a1 1 0 0 0-1.414-1.414zM4 4h16V2H4zm16 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 20 2zm.707.293A1 1 0 0 1 21 5h2a3 3 0 0 0-.879-2.121zM21 5v6h2V5zm0 6a9 9 0 0 1-2.636 6.364l1.414 1.414A11 11 0 0 0 23 11zm-2.636 6.364A9 9 0 0 1 12 20v2a11 11 0 0 0 7.778-3.222zM12 20a9 9 0 0 1-3.444-.685l-.766 1.848A11 11 0 0 0 12 22zm-3.444-.685a9 9 0 0 1-2.92-1.951l-1.414 1.414a11 11 0 0 0 3.568 2.385zm-2.92-1.951A9 9 0 0 1 3 11H1a11 11 0 0 0 3.222 7.778zM3 11V5H1v6zm0-6a1 1 0 0 1 .293-.707L1.879 2.879A3 3 0 0 0 1 5zm.293-.707A1 1 0 0 1 4 4V2a3 3 0 0 0-2.121.879zm4 6.414 4 4 1.414-1.414-4-4zm5.414 4 4-4-1.414-1.414-4 4z"
    />
  </svg>
);
export default SvgPocket;
